const config= {
    // RECAPTCHA_SITE_KEY_SINGUP: '6LeEj5EiAAAAALqmBik-Mh0VDFJsJtiRUbpn_H7I',
    // RECAPTCHA_SITE_KEY: '6Lc9l-8lAAAAAGu3OC345SzOim4eRIww5TYxSkPm',
    RECAPTCHA_SITE_KEY: '6Ld8ugQqAAAAAKIvrhgT3KonSSEo9ptON2Rss6g5',
    APP_ENV: process.env.REACT_APP_ENV,
    APP_URL: process.env.REACT_APP_APP_URL,
    WEB_URL: process.env.REACT_APP_WEB_URL,
};
// test
export default config;